import { render, staticRenderFns } from "./LinxSvg.vue?vue&type=template&id=b17fff2e"
import script from "./LinxSvg.vue?vue&type=script&lang=js"
export * from "./LinxSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports